import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.85, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children }) {
  return (
    <p className="flex items-center gap-3 font-accent text-[11px] font-medium uppercase tracking-[0.32em] text-terracotta">
      <span className="inline-block h-px w-8 bg-terracotta" aria-hidden="true" />
      {children}
    </p>
  );
}

export function SectionHeading({ tag, title, sub, align = "left" }) {
  const centered = align === "center";
  return (
    <div className={`max-w-3xl ${centered ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <div className={centered ? "flex justify-center" : ""}>
          <SectionTag>{tag}</SectionTag>
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-5 font-serif text-3xl font-medium leading-[1.08] tracking-tight text-bone sm:text-4xl lg:text-5xl">
          {title}
        </h2>
      </Reveal>
      {sub ? (
        <Reveal delay={0.16}>
          <p className="mt-4 text-base leading-relaxed text-stone sm:text-lg">{sub}</p>
        </Reveal>
      ) : null}
    </div>
  );
}

export default Reveal;